import { NgModule } from '@angular/core';
import { StickyDirective } from './sticky';

@NgModule({
    declarations: [
      StickyDirective
    ],
    exports: [
      StickyDirective
    ]
})
export class StickyModule { }